import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

export default function SEO({ ecmContent: { title, description } = {}, pathName }) {
  const titleElements = title
    ? [<title key="title">{title}</title>, <meta key="og:title" name="og:title" content={title} />]
    : null;
  const descriptionElements = description
    ? [
        <meta key="description" name="description" content={description} />,
        <meta key="og:description" name="og:description" content={description} />
      ]
    : null;

  return (
    <Helmet>
      {titleElements}
      {descriptionElements}
      <meta name="og:type" content="website" />
      <meta name="og:url" content={`https://developer.paypal.com/studio${pathName}`} />
    </Helmet>
  );
}

SEO.propTypes = {
  ecmContent: PropTypes.objectOf(PropTypes.string).isRequired,
  pathName: PropTypes.string.isRequired
};
